import { ParagraphWithoutPlate } from '@components/RichTextPlate/components/plate-ui/ParagraphElement'
import MarkdownToJSX from '@components/RichTextPlate/utils/MarkdownToJSX'
import { Box, Text } from '@ui'

const noopLookupUser = (userId: string) => ({
    userId,
    username: userId,
    usernameConfirmed: false,
    usernameEncrypted: false,
    displayName: userId,
    displayNameEncrypted: false,
})

const simpleMarkdownComponents = {
    p: ParagraphWithoutPlate,
    paragraph: ParagraphWithoutPlate,
    strong: ({ children }: React.PropsWithChildren) => (
        <Box fontWeight="strong" display="inline" as="strong">
            {children}
        </Box>
    ),
    em: ({ children }: React.PropsWithChildren) => (
        <Box fontStyle="italic" display="inline" as="em">
            {children}
        </Box>
    ),
    code: ({ children }: React.PropsWithChildren) => (
        <Box as="code" display="inline">
            {children}
        </Box>
    ),
    a: ({ href, children }: React.PropsWithChildren<{ href?: string }>) => (
        <Box
            as="a"
            href={href}
            display="inline"
            color="cta2"
            target="_blank"
            rel="noreferrer noopener"
        >
            {children}
        </Box>
    ),
}

export const SimpleMarkdown = ({ children }: { children: string }) => (
    <Text fontSize="sm">
        <MarkdownToJSX components={simpleMarkdownComponents} lookupUser={noopLookupUser}>
            {children}
        </MarkdownToJSX>
    </Text>
)
